import { Typography } from "@material-ui/core";
import clsx from "clsx";
import Button from "components/generics/Button";
import ReactMarkdown from "components/generics/ReactMarkdown";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    container: {
        background: "#fff",
    },
    header: {},
    headerWrapper: {
        width: "68%",
        margin: "0 auto"
    },
    title: {},
    description: {},
    "@media screen and (max-width:760px)": {
        headerWrapper: {
            width: "99%",
            margin: "0 auto"
        },
    }
})

function PressHeader({
    data
}) {

    const classes = useStyles();

    return (
        <>
            <div className="max-width">
                <div className={classes.container}>
                    <div className="sectionGap center">
                        <div className="ptb50">
                            <div className={classes.headerWrapper}>
                                <Typography
                                    variant="h1"
                                    className={classes.title}
                                >
                                    {data.title}
                                </Typography>
                                <ReactMarkdown
                                    source={data.description}
                                />
                                {/* <Button
                                variant="contained"
                                color="primary"
                                >
                                {data.button}
                            </Button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PressHeader;